<div class="tire-dot-number-body flex-column">
  <ng-container *ngFor="let dot of data?.dotNumbers; let i=index;">
    <div class="flex-between-end tire-dot-number-position gap-20px">
      <div class="flex-row w-40 gap-10px">
        <span>
          <img class="mt-1" style="height: 18px;" src="assets/img/icon/dot-number-black.svg" alt="dot number">
        </span>
        <div class="w-100">
          <app-input type="text" [maxLength]="30" theme="primary" label="Tire #{{i+1}}" [floatingLabel]="true"
            class="font-13" [id]="'dot-number-'+i" [hasHoverBorderBottom]="false" placeholder="Enter DOT#"
            [disabled]="false" [dropSpecialCharacters]="true" [hasHoverEffect]="false"
            (appChange)="handleChange($event, dot)" [value]="dot.dotNumber">
          </app-input>
        </div>
      </div>

      <div class="tire-position-type w-60">
        <app-switch-button [pTooltip]="dot.tooltip || ''" tooltipPosition="top" tooltipStyleClass="tire-dot-tooltip"
          [disabled]="!dot.dotNumber" [id]="'tire-position-'+i" valueField="value" field="label"
          [showselectedCircle]="false" [value]="getTireLabel(dot.tirePosition)" [options]="tirePositions"
          [showIcons]="false" (appChange)="onCardTypeSelect($event, dot)">
        </app-switch-button>
      </div>
    </div>
  </ng-container>
</div>
